module.exports = __webpack_public_path__ + "img/logo.109cd726.jpg";